import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

export const Pointer = styled(Box)({
  cursor: 'pointer',
})

export const Logo = styled('div')(({ theme }) => ({
  cursor: 'pointer',
  margin: '16px 32px',
}))
